import { render, staticRenderFns } from "./JSelectDepart.vue?vue&type=template&id=71008020&scoped=true&"
import script from "./JSelectDepart.vue?vue&type=script&lang=js&"
export * from "./JSelectDepart.vue?vue&type=script&lang=js&"
import style0 from "./JSelectDepart.vue?vue&type=style&index=0&id=71008020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71008020",
  null
  
)

export default component.exports